import * as React from 'react'
import { Text } from 'react-native'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'

type Props = {
  text: string
  headingLevel?: number
}

export const Title = ({ text, headingLevel }: Props) => {
  return (
    <Text
      accessibilityRole="header"
      accessibilityLevel={headingLevel}
      accessibilityLabel={text}
      style={{
        lineHeight: 22,
        fontSize: 22,
        color: `${Colors.alternateGray}`,
        ...Fonts.typeWithWeight.sofia,
      }}
    >
      {text}
    </Text>
  )
}
